/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_NotetakerInputs */



/**
* | output |
* | --- |
* | "Let the notetaker join" |
*
* @param {Meetings_NotetakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_notetaker = /** @type {((inputs?: Meetings_NotetakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_NotetakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Activeer de notetaker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le notetaker")
	return /** @type {LocalizedString} */ ("Let the notetaker join")
});